import React from "react";
import { useSelector } from "react-redux";

import { RootState } from "@/store/root-reducer";

type PolicyStartDateProps = {
  cmsData: {
    policyStartDateTitle: string;
  };
};

function PolicyStartDate({ cmsData }: Readonly<PolicyStartDateProps>) {
  const { policyStartDateTitle } = cmsData;

  const { attributes } = useSelector((state: RootState) => state.quote);
  const { tripDetails } = attributes;

  return (
    <div>
      <p className="font-body-font text-2xs font-[400] leading-[24px] text-text-functional-subtle">
        {policyStartDateTitle}
      </p>
      <p className="font-body-font text-xs font-[700] leading-[27px] text-interactive-secondary-default">
        {tripDetails
          ? tripDetails?.startDate?.split("-").reverse().join("/")
          : "DD/MM/YYYY"}
      </p>
    </div>
  );
}

export default PolicyStartDate;
